export default __webpack_public_path__ + "static/media/simProfile-2.5ce2df76.png";